/**
 * @desc        Language init config
 * @version     1.4 (hindi fix) - 08 Dec 24 **/

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'

export const supportedLngs = [
    { code: 'en-AU', text: 'English (AU)', icon: 'AU' },
    { code: 'en-CA', text: 'English (CA)', icon: 'CA' },
    { code: 'en-NZ', text: 'English (NZ)', icon: 'NZ' },
    { code: 'en-GB', text: 'English (UK)', icon: 'UK' },
    { code: 'en-US', text: 'English (US)', icon: 'US' },
    { code: 'en-ZA', text: 'English (ZA)', icon: 'ZA' },
    { code: 'es-AR', text: 'Español (AR)', icon: 'AR' },
    { code: 'es-MX', text: 'Español (MX)', icon: 'MX' },
    { code: 'hi-IN', text: 'हिंदी (आईएन)', icon: 'आईएन' },
    { code: 'pt-BR', text: 'Português (BR)', icon: 'BR' },
    { code: 'zh-CN', text: '中文 (中国)', icon: 'CN' },
    { code: 'bn-BD', text: 'বাংলা (বাংলাদেশ)', icon: 'BD' },
    { code: 'da-DK', text: 'Dansk (Danmark)', icon: 'DK' },
    { code: 'de-DE', text: 'Deutsch (Deutschland)', icon: 'DE' },
    { code: 'el-GR', text: 'Ελληνικά (Ελλάδα)', icon: 'GR' },
    { code: 'fi-FI', text: 'Suomi (Suomi)', icon: 'FI' },
    { code: 'fr-FR', text: 'Français (France)', icon: 'FR' },
    { code: 'id-ID', text: 'Bahasa Indonesia (Indonesia)', icon: 'ID' },
    { code: 'it-IT', text: 'Italiano (Italia)', icon: 'IT' },
    { code: 'ja-JP', text: '日本語 (日本)', icon: 'JP' },
    { code: 'ko-KR', text: '한국어 (대한민국)', icon: 'KR' },
    { code: 'nl-NL', text: 'Nederlands (Nederland)', icon: 'NL' },
    { code: 'no-NO', text: 'Norsk (Norge)', icon: 'NO' },
    { code: 'sw-KE', text: 'Kiswahili (Kenya)', icon: 'KE' },
    { code: 'tr-TR', text: 'Türkçe (Türkiye)', icon: 'TR' },
    { code: 'vi-VN', text: 'Tiếng Việt (Việt Nam)', icon: 'VN' },
]

i18n.use(
    resourcesToBackend((language, namespace) => {
        // Map legacy language codes to the new country-specific files
        const legacyLanguageMap = {
            hi: 'hi-IN',
            in: 'hi-IN',
            bn: 'bn-BD',
            da: 'da-DK',
            de: 'de-DE',
            el: 'el-GR',
            fi: 'fi-FI',
            fr: 'fr-FR',
            id: 'id-ID',
            it: 'it-IT',
            ja: 'ja-JP',
            ko: 'ko-KR',
            nl: 'nl-NL',
            no: 'no-NO',
            sw: 'sw-KE',
            tr: 'tr-TR',
            vi: 'vi-VN',
            zh: 'zh-CN',
        }
        const normalizedLanguage = legacyLanguageMap[language] || language
        return import(`./locales/${normalizedLanguage}/${namespace}.json`)
    }),
)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        userLang: getUserLocale,
        detection: {
            caches: ['localStorage', 'cookie'],
            order: ['localStorage', 'navigator', 'cookie'],
            lookupLocalStorage: 'i18nextLng',
            lookupSessionStorage: 'i18nextLng',
            cookieMinutes: 60,
            convertDetectedLanguage: lng => lng.replace('-', '_'),
        },
        load: 'currentOnly',
    })

export default i18n

export function getUserLocale(usrLng) {
    const lng = (usrLng || i18n.language || 'en-AU').replace('_', '-')
    if (lng === 'in') return 'hi-IN'
    const [lang, region] = lng.split('-')
    return region ? `${lang}-${region.toUpperCase()}` : lng
}
